module.exports = __webpack_public_path__ + "img/baas_41.81dae167.png";